import { render, staticRenderFns } from "./CustomerIndex.vue?vue&type=template&id=5202c130"
import script from "./CustomerIndex.vue?vue&type=script&lang=js"
export * from "./CustomerIndex.vue?vue&type=script&lang=js"
import style0 from "./CustomerIndex.vue?vue&type=style&index=0&id=5202c130&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports